import * as actionTypes from './actionTypes';

export const checkBoxSelect = (payload) => ({
  type: actionTypes.checkboxSelectType,
  payload
})

export const dropdownSelect = (payload) => ({
  type: actionTypes.dropdownSelectType,
  payload
})

export const startDateMobile = payload => ({
  type: actionTypes.fetchStartDateType,
  payload
});

export const endDateMobile = payload => ({
  type: actionTypes.fetchEndDateType,
  payload
});

export const viewButtonClick = payload => ({
  type: actionTypes.viewButtonClickType,
  payload
})

export const downloadClicked = payload => ({
  type: actionTypes.downloadClickType,
  payload
})

export const exitClicked = payload => ({
  type: actionTypes.exitClickType,
  payload
})

export const okClicked = payload => ({
  type: actionTypes.okClickType,
  payload
})

export const fetchDocumentCentreData = payload => ({
  type: actionTypes.fetchDocCentreDataType,
  payload
})

export const showMoreClick = payload => ({
  type: actionTypes.showMoreClickType,
  payload
})

export const filterGridData = payload => ({
  type: actionTypes.filterGridDataType,
  payload
})

export const switchButton = payload => ({
  type: actionTypes.switchButtonType,
  payload
})

export const accordionCheckBoxChange = (payload) => ({
  type: actionTypes.accordionCheckboxSelectType,
  payload
})

export const multiSelectOption = (payload) => ({
  type: actionTypes.multiSelectOptionType,
  payload
})

export const timeFrameDatesChange = (payload) => ({
  type: actionTypes.timeFrameChangeType,
  payload
})
